module.exports = __webpack_public_path__ + "img/pricer.c4e1ede0.png";